module.exports = __webpack_public_path__ + "img/Pot2.fce8af5e.svg";